var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isBannerShown)?_c('div',{staticClass:"closed-banner",class:{
    rounded: !!_vm.rounded
  },on:{"click":function($event){_vm.modalShown = true}}},[_c('div',{staticClass:"qrw-label-sm qrw-text-content-error-primary"},[_vm._v(" "+_vm._s(_vm.$t('closed_banner.title_'+_vm.type))+" ")]),_c('portal',[(_vm.modalShown)?_c('GenericClosedModal',{attrs:{"type":_vm.type,"schedule":_vm.scheduleObject},on:{"close":function($event){_vm.modalShown = false}}}):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }